export type IAddressValidationController = ReturnType<
  typeof AddressValidationControllerFactory
>;

export const AddressValidationControllerFactory = ({
  addressValidationService,
}: {
  addressValidationService: IAddressValidationService;
}) => {
  const validateAddress: IValidateAddress = async (address) => {
    return await addressValidationService.validateAddress(address);
  };

  return {
    validateAddress,
  };
};
